import axios from "axios";
import { redirectToLogin } from "../utils/navigate";
import { getApiBaseUrl } from "../utils/apiConfig";

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 15000,
});

const getErrorMessage = (error) =>
  String(
    error?.response?.data?.message ||
      error?.response?.message ||
      error?.message ||
      ""
  );

const clearAuthStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("authUser");
};

const isAuthRequest = (error) => {
  const url = String(error?.config?.url || "");
  return url.includes("/auth/login") || url.includes("/auth/forgot-password");
};

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAuthRequest(error)) {
      return Promise.reject(error);
    }

    const status = error.response?.status;
    const message = getErrorMessage(error).toLowerCase();
    const isAuthError =
      status === 401 ||
      message.includes("token expired") ||
      message.includes("invalid token") ||
      message.includes("no bearer token");

    if (isAuthError) {
      clearAuthStorage();
      if (!window.location.pathname.startsWith("/login")) {
        redirectToLogin();
      }
    }

    return Promise.reject(error);
  }
);

export default api;
